module.exports = __webpack_public_path__ + "media/images/sp/plans/inclusion_01-47876c71ed4c3b7e4f4c418cbee66534.png";